import { fg } from '@atlassian/jira-feature-gating';

const JiraAiAgentAvatarIssueViewHistoryRelayProvider = {
	get(): boolean {
		return fg('jira_ai_agent_avatar_issue_view_history');
	},
};

export default JiraAiAgentAvatarIssueViewHistoryRelayProvider;
